import type { ConceptDef } from '../types';

export const matchIdenticalPictures: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-identical-pictures',
  label: 'Match Identical Pictures',
  category: 'Matching',
  description: 'See a picture; tap the identical one among the tiles.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: '🍎', answer: '🍎' },
      { say: '🐶', answer: '🐶' },
      { say: '⚽', answer: '⚽' },
      { say: '🌳', answer: '🌳' },
      { say: '🚗', answer: '🚗' },
      { say: '⭐', answer: '⭐' },
    ],
  },
};
